import { TsButtonModule } from 'tsui';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatMomentDateModule } from '@angular/material-moment-adapter';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SavedViewAddComponent } from './modals/saved-view-add/saved-view-add.component';
import { TsCheckboxComponent } from 'tsui';

@NgModule({
  declarations: [SavedViewAddComponent],
  imports: [
    TsButtonModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TsCheckboxComponent,
    MatDatepickerModule,
    MatDividerModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatMenuModule,
    MatMomentDateModule,
  ],
  exports: [CommonModule, FormsModule, ReactiveFormsModule],
})
export class SavedViewsModule {}
